import { Obstruction } from '../obstruction.class';
import { ItemizedIslandMsrp } from '../types';
import { ItemizedLineItem } from '../../shared.types';

/**
 * Builds itemized MSRP for an obstruction with items ordered by natural spatial position.
 * Traverses panels in their existing order, groups left-to-right within each panel,
 * and items top-to-bottom within each group. Duplicate SKUs are merged into the
 * first spatial occurrence.
 * @param island Obstruction to calculate the itemized MSRP for
 * @returns ItemizedIslandMsrp
 */
export const getItemizedMsrpCfn = (island: Obstruction): ItemizedIslandMsrp => {
	const countertop = island.getCountertop();
	const msrpItems: Array<ItemizedLineItem> = [];
	const { children: panels = [] } = island.panels;

	// Traverse panels in natural order, groups left-to-right, items top-to-bottom
	panels.forEach((panel) => {
		const sortedGroups = [...panel.panelItemGroups.children].sort((a, b) => a.center.x - b.center.x);

		sortedGroups.forEach((panelItemGroup) => {
			const sortedItems = [...panelItemGroup.items.children].sort((a, b) => a.center.y - b.center.y);

			sortedItems.forEach((panelItem) => {
				const { fqSku } = panelItem.item;
				if (fqSku === 'CUSTOM') return;
				if (panelItem.item.category?.active) {
					const existing = msrpItems.find((item) => item.sku === fqSku);

					if (existing) {
						existing.qty += 1;
						existing.total += panelItem.item.msrp;
					} else {
						msrpItems.push({
							qty: 1,
							sku: fqSku,
							label: panelItem.item.label,
							category: panelItem.item.category?.description,
							description: panelItem.item.description,
							each: panelItem.item.msrp,
							total: panelItem.item.msrp
						});
					}
				}
			});
		});
	});

	const countertopItem = {
		qty: 1,
		sku: countertop?.sku ?? 'NO-SKU',
		category: 'Countertop',
		description: countertop?.material.displayName,
		each: countertop?.msrp,
		total: countertop?.msrp
	};

	return {
		countertop: countertopItem,
		island: island.msrpBase,
		description: island.description,
		items: msrpItems
	};
};
